import { appConstants } from 'utils/global-constants';

export const filterDeliveryMethods = (deliveryMethods, deliveryMethodDetails) => {
  let companionDelivery = null;

  const filteredObject = deliveryMethods.map((deliveryMethodsItem) => {
    const matchingDeliveryMethodDetails = deliveryMethodDetails.find(
      (deliveryMethodDetailsItem) =>
        deliveryMethodsItem.Id === deliveryMethodDetailsItem.DeliveryMethodId
    );
    if (matchingDeliveryMethodDetails?.DeliveryMethodId === appConstants.DeliveryMethodType.CompanionCard) {
      companionDelivery = matchingDeliveryMethodDetails;
    }

    return matchingDeliveryMethodDetails;
  });

  // Display only Companion Card when available
  if (companionDelivery) {
    return [companionDelivery];
  }
  return filteredObject.filter((obj) => obj !== undefined);
};
